import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { supabase } from "@/lib/supabaseClient";
import AddClientModal from "./AddClientModal";
import AddProjectWizard from "./AddProjectWizard";

export default function Clients() {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [showAddClient, setShowAddClient] = useState(false);
  const [wizardClientId, setWizardClientId] = useState(null);

  useEffect(() => {
    load();
  }, []);

  async function load() {
    setLoading(true);
    const { data, error: fetchError } = await supabase
      .from("clients")
      .select("*")
      .order("created_at", { ascending: false });
    if (fetchError) setError(fetchError.message);
    setClients(data || []);
    setLoading(false);
  }

  return (
    <div>
      <div className="flex items-center justify-between mb-1">
        <h1 className="text-xl font-semibold text-foreground">Clients</h1>
      </div>
      <p className="text-sm text-muted-foreground mb-6">{clients.length} clients</p>

      {error && (
        <p className="text-sm text-destructive bg-destructive/10 rounded-md px-3 py-2 mb-4">{error}</p>
      )}

      <button
        onClick={() => setShowAddClient(true)}
        className="bg-primary text-primary-foreground rounded-lg px-4 py-2 text-sm font-semibold mb-4"
      >
        + Add client
      </button>

      <div className="border border-border rounded-2xl bg-card overflow-hidden">
        {loading ? (
          <p className="text-sm text-muted-foreground p-5">Loading...</p>
        ) : clients.length === 0 ? (
          <p className="text-sm text-muted-foreground p-5">No clients yet, add your first one above.</p>
        ) : (
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-border">
                <th className="text-left font-mono text-[10.5px] uppercase tracking-wide text-muted-foreground px-5 py-3">
                  Client
                </th>
                <th className="text-left font-mono text-[10.5px] uppercase tracking-wide text-muted-foreground px-5 py-3">
                  Contact
                </th>
                <th className="text-left font-mono text-[10.5px] uppercase tracking-wide text-muted-foreground px-5 py-3">
                  Status
                </th>
              </tr>
            </thead>
            <tbody>
              {clients.map((c) => (
                <tr key={c.id} className="border-b border-border last:border-0 hover:bg-accent/60">
                  <td className="px-5 py-3.5 font-medium text-foreground">
                    <Link to={`/dashboard/agency/clients/${c.id}`} className="hover:underline">
                      {c.company_name}
                    </Link>
                  </td>
                  <td className="px-5 py-3.5 text-muted-foreground">
                    {c.contact_name}
                    <div className="text-xs">{c.contact_email}</div>
                  </td>
                  <td className="px-5 py-3.5">
                    <span className="font-mono text-[10.5px] bg-accent text-foreground rounded-full px-2.5 py-1">
                      {c.lifecycle_status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {showAddClient && (
        <AddClientModal
          onClose={() => setShowAddClient(false)}
          onSaved={() => {
            setShowAddClient(false);
            load();
          }}
          onSavedAndAddProject={(client) => {
            setShowAddClient(false);
            load();
            setWizardClientId(client.id);
          }}
        />
      )}

      {wizardClientId && (
        <AddProjectWizard
          presetClientId={wizardClientId}
          onClose={() => setWizardClientId(null)}
          onSaved={() => setWizardClientId(null)}
        />
      )}
    </div>
  );
}
